import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ProfileJobsEffects } from './profile-jobs.effects';

@NgModule({
  imports: [EffectsModule.forFeature([ProfileJobsEffects])],
})
export class ProfileJobsStoreModule {}
